<template>
  <a-card>
    <template slot="title">
      {{ document.docType }} :
      <verification-status
        :status="document.reviewResult"
        v-if="!hideReviewResult"
      />
    </template>
    <template v-if="/^image/.test(document.contentType)">
      <img
        class="app__img-preview"
        :src="document.content"
        @click="onSelectImageUrl(document.content)"
      >
    </template>
    <template v-if="/^application\/pdf/.test(document.contentType)">
      <span class="verification-document_pdf">
        <a
          :href="document.content"
          target="_blank"
          :download="`${document.docType}.pdf`"
        >
          {{ document.docType }}.pdf
        </a>
      </span>
    </template>
    <a-card-meta>
      <template slot="description">
        {{ document.contentType }}
      </template>
    </a-card-meta>
  </a-card>
</template>

<script>
import ACard from 'ant-design-vue/lib/card'
import VerificationStatus from '@/vue/common/verification-status'

export default {
  name: 'verification-document',
  components: {
    ACard,
    'a-card-meta': ACard.Meta,
    VerificationStatus,
  },
  props: {
    onSelectImageUrl: {
      type: Function,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    hideReviewResult: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
  @import '~ant-design-vue/lib/card/style/index.css';

  .verification-document_pdf embed {
    width: 100%;
  }
</style>
